import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch} from '@/store';
import {resetPerfectStore} from '@/store/slices/perfectStoreSlice';
import {ROUTES} from '@/utils/constants/routesConstants';
import {isPerfectStoreSetupInvalid} from '@/pages/PerfectStoreUtils';
import {usePerfectStore} from '@/hooks/usePerfectStore';
import {logger} from '@/helpers/logger';

export const usePerfectStoreReviewActions = ({
  formData,
  languages,
  isDisplayInvalid
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {handleDraft, handlePublish} = usePerfectStore();
  const [isCancel, setIsCancel] = useState(false);

  const handleCancel = () => setIsCancel(!isCancel);

  const onClickPrimaryButton = () => {
    dispatch(resetPerfectStore());
    navigate(ROUTES.PERFECT_STORE);
  };

  const handleDraftAction = async () => {
    try {
      const response = await handleDraft(formData);
      if (response?.success) {
        navigate(ROUTES.PERFECT_STORE);
      }
    } catch (error) {
      logger.error('Error saving Perfect Store draft:', error);
    }
  };

  const handlePublishAction = async () => {
    try {
      const response = await handlePublish(formData);
      if (response?.success) {
        navigate(ROUTES.PERFECT_STORE);
      }
    } catch (error) {
      logger.error('Error publishing Perfect Store:', error);
    }
  };

  const publishDisabled =
    isPerfectStoreSetupInvalid(formData) ||
    isDisplayInvalid(formData, languages);

  return {
    isCancel,
    handleCancel,
    onClickPrimaryButton,
    handleDraftAction,
    handlePublishAction,
    publishDisabled
  };
};
